import { CHAT_UI_PREFIX } from 'constants/id';
import { VENDOR_COMMANDS } from 'constants/vendor-commands';
import { EndAdvocateChatModalConfigType } from './EndAdvocateChatModal.types';

export const END_CHAT: string = 'endChat';
export const CANCEL_ESCALATION: string = 'cancelEscalation';

export const config: EndAdvocateChatModalConfigType = {
  [END_CHAT]: {
    containerId: 'end-advocate-chat-confirmation',
    title: 'Would you like to end this chat?',
    body: 'We’ll end your conversation with our Advocate. You can always ask Sebastian for help.',
    cancel: 'Cancel',
    submitButton: 'End Chat',
    vendorCommand: VENDOR_COMMANDS.CARVANA_END_CHAT,
    analtyics: {
      submitClickId: `${CHAT_UI_PREFIX}-end-chat-button`,
      overlayClickId: `${CHAT_UI_PREFIX}-end-chat-overlay`,
      cancelClickId: `${CHAT_UI_PREFIX}-cancel-end-chat-button`,
      closeClickId: `${CHAT_UI_PREFIX}-close-end-chat-button`,
    },
  },
  [CANCEL_ESCALATION]: {
    containerId: 'end-advocate-chat-cancel-escalation',
    title: 'Would you like to cancel your request?',
    body: "We'll cancel your request for an Advocate. You can always ask Sebastian for help.",
    cancel: 'Cancel',
    submitButton: 'Yes, Cancel Request',
    vendorCommand: VENDOR_COMMANDS.CARVANA_CANCEL_ESCALATION,
    analtyics: {
      submitClickId: `${CHAT_UI_PREFIX}-cancel-escalation-button`,
      overlayClickId: `${CHAT_UI_PREFIX}-cancel-escalation-overlay`,
      cancelClickId: `${CHAT_UI_PREFIX}-cancel-cancel-escalation-button`,
      closeClickId: `${CHAT_UI_PREFIX}-close-cancel-escalation-button`,
    },
  },
};
